var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventsIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "31px",
    viewBox: "0 0 30 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/events/green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Walk-in/out",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons",
    transform: "translate(-102.000000, -582.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-nav",
    transform: "translate(21.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/events/green",
    transform: "translate(81.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,2.77777778 L29,2.77777778",
    id: "Line",
    stroke: "#5f00a0",
    strokeWidth: 1.66666667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,7.22222222 L29,7.22222222",
    id: "Line-Copy",
    stroke: "#5f00a0",
    strokeWidth: 1.66666667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,11.6666667 L29,11.6666667",
    id: "Line-Copy-2",
    stroke: "#5f00a0",
    strokeWidth: 1.66666667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16.1111111 L29,16.1111111",
    id: "Line-Copy-3",
    stroke: "#5f00a0",
    strokeWidth: 1.66666667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22222222,20.5555556 L29,20.5555556",
    id: "Line-Copy-4",
    stroke: "#5f00a0",
    strokeWidth: 1.66666667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22222222,25 L29,25",
    id: "Line-Copy-5",
    stroke: "#5f00a0",
    strokeWidth: 1.66666667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22222222,29.4444444 L29,29.4444444",
    id: "Line-Copy-6",
    stroke: "#5f00a0",
    strokeWidth: 1.66666667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9244444,16.025641 L13.9244444,6.21794872 L1.85333333,6.21794872 L1.85333333,16.025641 L13.9244444,16.025641 Z M13.9244444,1.75213675 C14.3945703,1.75213675 14.8024674,1.93019765 15.1481481,2.28632479 C15.4938289,2.64245192 15.6666667,3.06267564 15.6666667,3.54700855 L15.6666667,16.025641 C15.6666667,16.5099739 15.4938289,16.9230752 15.1481481,17.2649573 C14.8024674,17.6068393 14.3945703,17.7777778 13.9244444,17.7777778 L1.85333333,17.7777778 C1.3693803,17.7777778 0.958026385,17.6068393 0.619259259,17.2649573 C0.280492133,16.9230752 0.111111111,16.5099739 0.111111111,16.025641 L0.111111111,3.54700855 C0.111111111,3.06267564 0.280492133,2.64245192 0.619259259,2.28632479 C0.958026385,1.93019765 1.3693803,1.75213675 1.85333333,1.75213675 L2.7037037,1.75213675 L2.7037037,0 L4.44592593,0 L4.44592593,1.75213675 L11.3318519,1.75213675 L11.3318519,0 L13.0740741,0 L13.0740741,1.75213675 L13.9244444,1.75213675 Z M12.2237037,8.01282051 L12.2237037,9.76495726 L10.4814815,9.76495726 L10.4814815,8.01282051 L12.2237037,8.01282051 Z M8.73925926,8.01282051 L8.73925926,9.76495726 L7.03851852,9.76495726 L7.03851852,8.01282051 L8.73925926,8.01282051 Z M5.2962963,8.01282051 L5.2962963,9.76495726 L3.55407407,9.76495726 L3.55407407,8.01282051 L5.2962963,8.01282051 Z",
    id: "\\uE8D4",
    fill: "#5f00a0",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIconGreen);
export default __webpack_public_path__ + "static/media/events_icon_green.b7532123d36eb7cdc348dcbd3cba62ae.svg";
export { ForwardRef as ReactComponent };